<template>
	<div style="width:90%">

		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
				<el-form-item label="类型标题:">
					<el-input v-model="searchInfo.typeName" placeholder="请输入类型标题" />
				</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search">搜索</el-button>
						<el-button @click="empty">清空</el-button>
					</el-form-item>
					<div style="width: 200px;display: inline-block;"></div>
					<el-form-item>
						<el-button type="primary" @click="editialogVisible('')">新增
						</el-button>
					</el-form-item>

				</el-form>
			</header>
		</div>

		<el-table :data="getNewsPostList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="typeName" label="类型标题" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="typeKey" label="类型键值" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="orderIndex" label="排序" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isShow" label="是否显示" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==false">否</span>
					<span v-else>是</span>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center">
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="upStatus(scope.row.id,scope.row.status)" v-if="scope.row.status">禁用</el-button>
					<el-button size="small" type="text" @click="upStatus(scope.row.id,scope.row.status)" v-if="!scope.row.status">启用</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="getNewsPostList.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="getNewsPostList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="详情" :visible.sync="showContentDialog" width="50%" :close-on-click-modal="false">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 查看图片 -->
		<el-dialog title="详情" :visible.sync="readingecord" width="50%" :close-on-click-modal="false">
			<img :src="images" style="width: 100%;" />

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="readingecord = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 新增、编辑 -->
		<el-dialog style="float:rigin" :title="poupTitle" :visible.sync="editDialogVisible" width="500px"
		:close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" size="medium">
					
					<el-form-item label="标题:">
						<el-input v-model="form.typeName" placeholder="请输入标题" style="width:300px;"/>
					</el-form-item>
					<el-form-item label="键值:">
						<el-input v-model="form.typeKey" placeholder="请输入键值" style="width:300px;"/>
					</el-form-item>
					
					<el-form-item label="排序:">
						<el-input v-model="form.orderIndex" placeholder="请输入排序数字"  type="number" style="width:300px;"/>
					</el-form-item>
				</el-form>
				<div style="text-align: center;">
					<el-button @click="editDialogVisible = false">取 消</el-button>
					<el-button  type="primary" @click="toEdit()" :loading="toEditLoading">提交</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				systemMessage: null,
				loading: false,
				getNewsPostList: [], //消息
				typeList: [],
				userList: [],
				MessageReadingRecordList: [], //阅读记录
				dialogVisible: false,
				editDialogVisible: false,
				readingecord: false,
				form: {
					id: 0,
					title: "",
					intro: "",
					content: "",
					images: "",
					isShow: true
				},
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false,
				images: "",
				httpUrl: urls,
				editorOption: { // 富文本编辑器配置
					placeholder: '请输入内容',
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
								[{
									'header': 1
								}, {
									'header': 2
								}], // 标题，键值对的形式；1、2表示字体大小
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], // 列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'align': []
								}], // 对齐方式
								['clean'], // 清除字体样式
								['image'] // 上传图片、上传视频
							],
							handlers: {
								'image': function (value) {
									if (value) {
										document.querySelector('#lpc-quill .upload-demo input').click()
									} else {
										this.quill.format('image', false)
									}
								}
							}
						}
					},
					theme: 'snow'
				},

				poupTitle: '',

				toEditLoading: false,
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			empty() {
				this.searchInfo.typeName = '';
			},
			search() {
				this.findNewsPostList()
			},
			//上传logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				console.log(1)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.images = res.data
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			searchUserName() {
				this.loading = true
				let webData = {
					pageNum: 1,
					pageSize: 10000,
					username: this.form.username ? this.form.username : null
				}
				this.$api.getUserList(webData).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.userList = res.data.list
					}
					this.loading = false
				})

			},
			showContent(content) {
				this.contentValue = content
				// console.log(this.contentValue)
				this.showContentDialog = true
			},
			//查看图片
			showImages(images) {
				this.images = ""
				this.readingecord = true;
				this.images = images
			},
			upStatus(id,status){
				this.$confirm('此操作将改变帮助是否显示, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.upStatus({id:id,status:!status}).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findNewsPostList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//编辑弹框
			editialogVisible(id) {
				// this.images = ""
				if (id) {
					//编辑查询
					this.ids = id
					this.poupTitle = '编辑'
					this.$api.findArticleTypeId(id).then((res) => { //通过id查询消息
						if (res.state == 'success') {
							this.form = res.data;
							this.form.position=Number(this.form.position)
							// this.images = res.data.images
						}
					})
				} else {
					this.ids = ""
					this.form = {}
					this.poupTitle = '新增'
				}
				this.editDialogVisible = true;
			},
			toEdit() {
				this.toEditLoading = true;
				if (this.ids) {
					//编辑
					// this.form.images = this.images
					// console.log(this.form)
					this.$api.changeArticleType(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.findNewsPostList();
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				} else {
					//添加
					// let data = {
					// 	title: this.form.title,
					// 	titleEn: this.form.titleEn,
					// 	userId: this.form.userId,
					// 	typeId: this.form.typeId,
					// 	action: this.form.action,
					// 	status: this.form.status,
					// 	content: this.form.content,
					// 	contentEn: this.form.contentEn
					// }
					// this.form.images = this.images
					// console.log(this.form);
					this.$api.addArticleType(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.findNewsPostList();
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				}
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			//消息
			pageChange(data) {
				this.page.pageNum = data
				this.findNewsPostList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findNewsPostList()
			},
			findNewsPostList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					typeName: this.searchInfo.typeName,
				};
				this.$api.findArticleTypes(data).then((res) => { //list
					if (res.state == 'success') {
						this.getNewsPostList = res.data
						this.loading = false
					}
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delArticleType(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findNewsPostList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			beforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			upScuccess(res, file) {
				// console.log(res)
				const quill = this.$refs.myQuillEditor.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
				// console.log(quill)
			},
			uploadError() {
				this.$message.error('图片上传失败')
			},
			onEditorReady(editor) { // 准备编辑器
				// console.log(editor)
			},
			beforeUploaden(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			upScuccessen(res, file) {
				const quill = this.$refs.myQuillEditoren.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
			},
			uploadErroren() {
				this.$message.error('图片上传失败')
			},
			onEditorReadyen(editor) { // 准备编辑器
				// console.log(editor)
			},
		},
		created() {
			this.findNewsPostList();
		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>